import { render, staticRenderFns } from "./executionStandard.vue?vue&type=template&id=06df86a4"
import script from "./executionStandard.vue?vue&type=script&lang=js"
export * from "./executionStandard.vue?vue&type=script&lang=js"
import style0 from "./executionStandard.vue?vue&type=style&index=0&id=06df86a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports